import React from 'react';
import styled from 'styled-components';
import {Button, FlexColumn, Heading, Text, tokensForThemeProvider} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';

const tokens = tokensForThemeProvider.sky.sys;

const Wrapper = styled(FlexColumn)`
	align-items: center;
	text-align: center;
	gap: ${tokens.spacing['200']};
	padding: ${tokens.spacing['800']} ${tokens.spacing['400']};
`;

/** Shown in place of the table when the data fetch rejected (non-2xx or network failure).
 * Deliberately distinct from `EmptyReportState`: that one tells the user the report ran and matched
 * nothing, which would be a lie here — we do not know how many tasks match. Offers a retry because
 * the fetch is otherwise only re-run when the definition changes. */
export function ReportErrorState({onRetry}: {onRetry: () => void}): JSX.Element {
	const {formatMessage} = useIntl();

	return (
		<Wrapper data-cy={'ai-report-builder-error'}>
			<Heading size={'3'}>{formatMessage({id: 'ai_report_builder.error.title'})}</Heading>
			<Text>{formatMessage({id: 'ai_report_builder.error.body'})}</Text>
			<Button emphasis={'medium'} onPress={onRetry} data-cy={'ai-report-builder-retry'}>
				{formatMessage({id: 'ai_report_builder.error.retry'})}
			</Button>
		</Wrapper>
	);
}
